'use strict';

var config = require('../../../js/config'),
  $global = require('../../../js/globalElements'),
  mediator = require('../../../js/mediator'),
  ShowHide = require('../../../js/components/ShowHide'),

  DivisionsMenuView = ShowHide.extend({

    initialize: function() {
      this.DivisionsVisible = false;
      this.type = this.$el.find('a.js-division-dropdown');
      this.animation = 'slide';
      this.divisionCloseEl = this.$el.find('a#divisions-menu-close-button');
      mediator.on(config.events.ui.resize, this.updateOnResize, this);
      mediator.on(config.events.ui.scroll, this.onScroll, this);
      this.setup();
    },

    onShow: function() {
      const DIVISION_SHOW = `${config.classes.hasHeaderDropdown} ${config.classes.hasDivisionsMenu}`;
      this.DivisionsVisible = !this.DivisionsVisible;
      $global.$body.addClass(DIVISION_SHOW);
      mediator.trigger(config.events.header.openingDropdownView, this);
    },

    onHide: function() {
      this.DivisionsVisible = !this.DivisionsVisible;
      $global.$body.removeClass(config.classes.hasDivisionsMenu);
    },

    updateOnResize: function() {
      if (this.DivisionsVisible && window.innerWidth <= config.breakpoints.laptop) {
        this.closeMenu();
      }
    },

    onScroll: function() {
      if (this.DivisionsVisible === true && $global.$body.hasClass(config.classes.isMinimisedHeader)) {
        this.closeMenu();
      }
    },

    closeMenu: function() {
      if (this.divisionCloseEl && this.divisionCloseEl.length > 0) {
        this.divisionCloseEl[0].click();
      }
    }
  });

module.exports = DivisionsMenuView;



// WEBPACK FOOTER //
// ./assets/components/Header/js/DivisionMenuView.js